export default function (value) {
  return value > 0
}
